module.exports = __webpack_public_path__ + "img/Screenshot_GL.67270fd6.svg";